import { render, staticRenderFns } from "./CmsIcmRoleAllo.vue?vue&type=template&id=3e77e452&scoped=true&"
import script from "./CmsIcmRoleAllo.vue?vue&type=script&lang=js&"
export * from "./CmsIcmRoleAllo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77e452",
  null
  
)

export default component.exports